/** Stable client-side execution identity — never derived from address, position, or group. */

export function createClientExecutionUid(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `exec-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

export function ensureClientExecutionUid(existing?: string | null): string {
  const trimmed = String(existing ?? '').trim();
  return trimmed.length > 0 ? trimmed : createClientExecutionUid();
}

/** Preserve uid through clone/rebuild; assign only when missing. */
export function preserveStopUid<T extends { uid?: string }>(stop: T): T & { uid: string } {
  return { ...stop, uid: ensureClientExecutionUid(stop.uid) };
}
